import React from "react";
import DetailsSectionLabel from "./DetailsSectionLabel";
import pdfIcon from "./pdfIcon.png";
import NoDataMessage from "./NoDataMessage";

export default function DocumentsTab({ data }) {
  console.log(data);
  return (
    <div>
      <DetailsSectionLabel label="DOCUMENTS" isFirst={true} />
      <p className="text-xs leading-tight">
        Note: All transfer declarations prior to January 1st 2011 are not
        available online. These documents need to be obtained in person at the
        Recorder's office; for further assistance, please contact{" "}
        <b>815-334-4110</b> or email{" "}
        <a
          className="text-mchenry-orange underline cursor-pointer hover:brightness-110"
          target="_blank"
          rel="norefferer"
          href="mailto:recorders@mchenrycountyil.gov"
        >
          recorders@mchenrycountyil.gov
        </a>
        .
      </p>
      <hr className="my-3" />
      {data.ElectronicDocuments.length > 0 ? (
        <div>
          {data.ElectronicDocuments.filter(x => x.Destroyed !== "true").map((doc, i) => (
            <div key={i}>
              <a

                href={`https://publicrecords.mchenrycountyil.gov/AppNet/docpop/docpop.aspx?clienttype=html&docId=${doc.ID}`}
                target="_blank"
                className="ml-1 cursor-pointer hover:underline flex text-xs items-center my-1"
              >
                <img src={pdfIcon} />
                <span className="ml-1">{doc.Name}</span>
              </a>
            </div>
          ))}
        </div>
      ) : (
        <NoDataMessage />
      )}
    </div>
  );
}
